/* eslint-disable eqeqeq */
/* eslint-disable no-unused-vars */
import {
  Container,
  Grid,
  SvgIcon,
  Table,
  TableBody,
  TableHead,
  TableRow,
  Typography,
} from "@material-ui/core";
import React, { useCallback, useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import Swal from "sweetalert2";
import { globalColors } from "../../../../../../../_metronic/_assets/sass/custom/globalColors";
import { ReactComponent as approvedIcon } from "../../../../../../assets/custom-icons/check-circle.svg";
import { ReactComponent as downloadIcon } from "../../../../../../assets/custom-icons/download.svg";
import { ReactComponent as informationIcon } from "../../../../../../assets/custom-icons/information-circle.svg";
import { ReactComponent as paperClipIcon } from "../../../../../../assets/custom-icons/paper-clip.svg";
import { ReactComponent as deniedIcon } from "../../../../../../assets/custom-icons/x-circle.svg";
import { USER_ROLES } from "../../../../../../enum/UserRoles";
import DocumentStatusEnum from "../../../../../../enums/DocumentStatusEnum";
import UserRole from "../../../../../../enums/UserRole";
import CrudActions from "../../../../../../partials/datatable/CrudActions";
import {
  StyledTableCell,
  StyledTableRow,
} from "../../../../../../partials/datatable/styles";
import { AppAPIService } from "../../../../../../services/AppAPIService";
import { UploadModal } from "../../../Lawsuit/components/Document/components/UploadModal/UploadModal";
import { ConfirmModal } from "../../../Parametrizacao/Components/Processual/components/ConfirmModal";
import {
  getDisplayFromStatusHelper,
  shouldShowDeclineButton,
} from "../../helpers/getDisplayFromStatusHelper";
import { getLabelAndColorFromStatusHelper } from "../../helpers/getLabelAndColorFromStatusHelper";
import RejectingDocumentModal from "./components/CreateModal/RejectingDocumentModal";
import RejectingDocumentModalInfo from "./components/CreateModal/RejectingDocumentModalInfo";
import { useMediaQuery } from "@mui/material";
import Loading from "../../../../../home/components/Loading";
import { handleStatusDocument } from "../../utils/handleStatusDocument";
import { useDispatch, useSelector } from "react-redux";

export const UserDocumentsTable = (props) => {
  let api = AppAPIService.getInstance();
  const [showConfirmDeleteModal, setShowConfirmDeleteModal] = useState(false);
  const [confirmedDelete, setConfirmedDelete] = useState(false);
  const [loading, setLoading] = useState(false);
  const [documentOptions, setDocumentOptions] = useState([]);
  const history = useHistory();
  const authUser = useSelector((state) => state.auth.user);
  const userRole = authUser?.role;
  const srollableTable = useMediaQuery("(max-width: 768px)");

  const [filesList, setFilesList] = useState([]);
  const dispatch = useDispatch();

  const getDocumentOptions = useCallback(async () => {
    try {
      setLoading(true);
      const response = await api.makeHttpRequest({
        url: `/document/list-paginated`,
        method: "GET",
      });
      const documentOptionsFromApi = response.data.map((document) => {
        return { value: document.id, label: document.name };
      });
      setDocumentOptions(documentOptionsFromApi);
    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false);
    }
  }, [api]);
  useEffect(() => {
    getDocumentOptions();
  }, [getDocumentOptions]);

  const [tableHeaders, setTableHeaders] = useState([
    "Ações",
    "Documento",
    "Arquivo",
    "Data de modificação",
    "Status",
  ]);

  const [filterTextDocument, setFilterTextDocument] = useState("");

  const [documents, setDocuments] = useState([]);

  const [showUpload, setShowUpload] = useState(false);
  const [dadosLawsuit, setDadosLawsuit] = useState();
  const [lawsuit, setLawsuit] = useState(null);

  const [idToDelete, setIdToDelete] = useState(null);

  const getDocuments = useCallback(async () => {
    try {
      setLoading(true);
      const response = await api.makeHttpRequest({
        method: "GET",
        url: `/document/list-paginated?userId=${props.userId}`,
      });
      if (userRole === UserRole.CLIENT) {
        setDocuments(response.data.filter((document) => document.active));
      } else {
        setDocuments(response.data);
      }
    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false);
    }
  }, [api, props.userId, userRole]);

  const changeOriginalMessage = (message) => {
    if (message === "This document has already been rejected") {
      return "Este documento já foi rejeitado";
    }

    if (message === "There is no valid document for updating") {
      return "Não há documento válido para atualização";
    }

    return;
  };

  const handleConfirmDelete = useCallback(
    async (id) => {
      try {
        setLoading(true);
        const result = await api.makeHttpRequest({
          method: "DELETE",
          url: `/document/${id}`,
        });

        if (result?.HttpStatus == 404) {
          Swal.fire(
            "Erro!",
            "Erro ao deletar documento, não encontrado.",
            "error"
          );
          return;
        }
        if (result?.HttpStatus !== 200) {
          Swal.fire("Erro!", "Erro ao deletar documento.", "error");
          return;
        }

        props.setReload(!props.reload);
        if (props?.setUserReload && props?.userReload)
          props.setUserReload(!props.userReload);
        setLoading(false);
        Swal.fire("Sucesso!", "documento deletado com sucesso.", "success");
      } catch (e) {
        Swal.fire("Erro!", "Erro ao deletar documento.", "error");
      } finally {
        getDocuments();
      }

      setConfirmedDelete(false);
      setLoading(false);
    },
    [api, getDocuments, props]
  );

  const handleDeleteRecord = (id) => {
    setIdToDelete(id);
    setShowConfirmDeleteModal(true);
  };

  const handleConfirmChangeStatus = useCallback(
    async (obj) => {
      try {
        setLoading(true);
        await api.makeHttpRequest({
          method: "PATCH",
          url: `/document/toggle/${obj.id}`,
        });

        setLoading(false);
        props.setReload(!props.reload);
        if (props?.setUserReload && props?.userReload)
          props.setUserReload(!props.userReload);

        const documentStatus = !obj.active ? "ativado" : "desativado";

        Swal.fire({
          title: "Sucesso!",
          text: `Documento ${documentStatus} com sucesso!`,
          icon: "success",
          cancelButtonText: "Sair",
        });
      } catch (e) {
        Swal.fire("Erro!", "Erro ao alterar status do documento.", "error");
      } finally {
        setLoading(false);
        if (props?.handleGetParent) {
          props.handleGetParent();
        }
        getDocuments();
      }
    },
    [api, getDocuments, props]
  );

  const handleOpenUploadModal = useCallback(
    (row) => {
      setShowUpload(true);
      setDadosLawsuit({
        documentCategoryId: row.documentCategoryId,
        documentId: row?.id,
        userId: props.userId,
      });
    },
    [props.userId]
  );

  const handleDownload = useCallback(
    async (filesKeys, row) => {
      if (!filesKeys || filesKeys.length === 0) {
        Swal.fire("Desculpe!", "Não contém arquivo!", "error");
      } else {
        handleOpenUploadModal(row);
        setFilesList(filesKeys);
      }
    },
    [handleOpenUploadModal]
  );

  const handleAttach = useCallback(
    async (filesKeys, row) => {
      if (filesKeys && filesKeys.length > 0) {
        setFilesList(filesKeys);
      }
      handleOpenUploadModal(row);
    },
    [handleOpenUploadModal]
  );

  useEffect(() => {
    getDocuments();

    if (props?.handleGetHistory) {
      props.handleGetHistory(props.userId);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [getDocuments, props.reload]);

  useEffect(() => {
    if (confirmedDelete) {
      handleConfirmDelete(idToDelete);
    }
  }, [confirmedDelete, handleConfirmDelete, idToDelete]);

  const approveDocument = useCallback(
    async (id) => {
      try {
        setLoading(true);

        await dispatch(
          handleStatusDocument(id, "docUser", DocumentStatusEnum.COMPLETED)
        );

        setLoading(false);
        props.setReload(!props.reload);
        if (props?.setUserReload && props?.userReload)
          props.setUserReload(!props.userReload);

        Swal.fire(
          "Sucesso!",
          "Documento aprovado com sucesso.",
          "success"
        ).then(() => {
          getDocuments();
        });
      } catch (e) {
        Swal.fire("Erro!", "Erro ao aprovar documento.", "error");
      } finally {
        setLoading(false);
      }
    },
    [dispatch, getDocuments, props]
  );

  let crudActions =
    userRole === USER_ROLES.COLLABORATOR
      ? ["toggle"]
      : ["toggle", "delete"];
  let crudOtherActions = ["download"];

  const [observationReject, setObservationReject] = useState("");
  const [rejectingDocumentId, setRejectingDocumentId] = useState(null);
  const [showRejectModal, setShowRejectModal] = useState(false);
  const [showRejectModalInfo, setShowRejectModalInfo] = useState(false);

  const rejectDocument = useCallback(
    async (id) => {
      try {
        setLoading(true);

        await dispatch(
          handleStatusDocument(
            id,
            "docUser",
            DocumentStatusEnum.REJECTED,
            observationReject
          )
        );
        setLoading(false);
        props.setReload(!props.reload);
        if (props?.setUserReload && props?.userReload)
          props.setUserReload(!props.userReload);
        Swal.fire(
          "Sucesso!",
          "Documento rejeitado com sucesso.",
          "success"
        ).then(() => {
          getDocuments();
        });
      } catch (e) {
        const message = changeOriginalMessage(e?.response?.data?.reason);

        Swal.fire(
          "Erro!",
          `${message ?? "Erro ao rejeitar documento."}`,
          "error"
        );
      } finally {
        setLoading(false);
      }
    },
    [dispatch, getDocuments, observationReject, props]
  );

  return (
    <>
      {loading ? <Loading isLoading={loading} /> : null}
      <Container
        style={{
          boxShadow: "none",
          padding: 0,
          margin: 0,
        }}
        maxWidth="xl"
      >
        <RejectingDocumentModal
          open={showRejectModal}
          handleOpen={setShowRejectModal}
          observationReject={observationReject}
          setObservationReject={setObservationReject}
          rejectingDocumentId={rejectingDocumentId}
          rejectDocument={rejectDocument}
        />

        <RejectingDocumentModalInfo
          open={showRejectModalInfo}
          handleOpen={setShowRejectModalInfo}
          observationReject={observationReject}
        />

        <ConfirmModal
          open={showConfirmDeleteModal}
          handleOpen={setShowConfirmDeleteModal}
          handleConfirm={handleConfirmDelete}
          setConfirmedDelete={setConfirmedDelete}
          id={idToDelete}
          setId={setIdToDelete}
        />
        <Grid
          xl={12}
          lg={12}
          md={12}
          sm={12}
          xs={12}
          container
          style={{
            padding: 0,
          }}
        >
          <UploadModal
            open={showUpload}
            refetchLogs={props.refetchLogs}
            handleOpen={setShowUpload}
            dados={dadosLawsuit}
            handleGetDocuments={getDocuments}
            handleGetParent={props?.handleGetParent}
            reload={props.reload}
            setReload={props.setReload}
            userReload={props.userReload}
            setUserReload={props.setUserReload}
            filesList={filesList}
          />
          <Container
            maxWidth="xl"
            style={{
              boxShadow: "none",
              border: "1px solid #e0e0e0",
              borderRadius: "5px",
              padding: 0,
              textAlign: "left",
              maxWidth: srollableTable ? "calc(100vw - 70px)" : "100%",
              overflowX: srollableTable ? "scroll" : "hidden",
            }}
          >
            <Table
              className="table"
              style={{
                marginTop: "0px",
                marginBottom: "0px",
                padding: "0px",
                borderCollapse: "collapse",
                borderSpacing: "0px",
                width: "100%",
              }}
            >
              <TableHead
                style={{
                  backgroundColor: globalColors.secondaryColor3,
                }}
              >
                <TableRow
                  style={{
                    textAlign: "left",
                    backgroundColor: globalColors.secondaryColor3,
                  }}
                >
                  {tableHeaders.map((header, index) => (
                    <StyledTableCell
                      key={index}
                      style={{
                        textAlign: [
                          "Data de modificação",
                          "Status",
                          "Prazo de Envio",
                        ].includes(header)
                          ? "center"
                          : "left",
                        backgroundColor: globalColors.secondaryColor3,
                        border: "none",
                      }}
                    >
                      {header}
                    </StyledTableCell>
                  ))}
                </TableRow>
              </TableHead>
              <TableBody
                style={{
                  textAlign: "left",
                }}
              >
                {documents?.map((row) => (
                  <StyledTableRow
                    key={row.id}
                    style={{
                      backgroundColor:
                        row.id % 2 === 0
                          ? "#fffff"
                          : "rgba(225, 222, 219, 0.25)",
                    }}
                  >
                    <StyledTableCell
                      style={{
                        color: globalColors.backgroundColor2,
                        padding: "4px 10px",
                        textAlign: "left",
                        width: "200px",
                      }}
                    >
                      <div
                        style={{
                          padding: 0,
                          margin: 0,
                          justifyContent: "flex-start",
                          alignItems: "center",
                          color: "red",
                          display: "flex",
                          flexDirection: "row",
                        }}
                      >
                        <div
                          style={{
                            margin: 0,
                            padding: 0,
                            display:
                              userRole === USER_ROLES.ADMIN ||
                              userRole === USER_ROLES.COLLABORATOR
                                ? "flex"
                                : "none",
                            justifyContent: "center",
                          }}
                          maxWidth="xl"
                        >
                          <CrudActions
                            actions={crudActions}
                            module="processo"
                            onConfirmChangeStatus={handleConfirmChangeStatus}
                            onConfirmDelete={handleConfirmDelete}
                            id={row.id}
                            obj={row}
                            titleMessageDelete={""}
                            addMessage={"Deseja deletar esse documento?"}
                          />
                        </div>
                        {row.status !== DocumentStatusEnum.COMPLETED && (
                          <SvgIcon
                            component={paperClipIcon}
                            onClick={() => {
                              handleAttach(
                                row?.files.map((file) => ({
                                  name: file.name,
                                  fileKey: file.fileKey,
                                  id: file?.id,
                                  documentId: row?.id,
                                })),
                                row
                              );
                            }}
                            style={{
                              width: "20px",
                              height: "20px",
                              color: globalColors.backgroundColor2,
                              fill: "transparent",
                              cursor: "pointer",
                              marginRight: "10px",
                              display: "block",
                            }}
                            title={"Anexar documento"}
                          />
                        )}
                        <SvgIcon
                          component={approvedIcon}
                          onClick={() => {
                            approveDocument(row.id);
                          }}
                          style={{
                            width: "20px",
                            height: "20px",
                            color: globalColors.backgroundColor2,
                            marginRight: "10px",
                            fill: "transparent",
                            cursor: "pointer",
                            display: getDisplayFromStatusHelper(
                              row.status,
                              authUser
                            ),
                          }}
                          title={"Aprovar documento anexado"}
                        />
                        <SvgIcon
                          component={deniedIcon}
                          onClick={() => {
                            setObservationReject("");
                            setRejectingDocumentId(row.id);
                            setShowRejectModal(true);
                          }}
                          style={{
                            width: "20px",
                            height: "20px",
                            color: globalColors.backgroundColor2,
                            fill: "transparent",
                            cursor: "pointer",
                            display: shouldShowDeclineButton(
                              row.status,
                              authUser
                            ),
                            margin: "0",
                            marginRight: "10px",
                          }}
                          title={"Rejeitar documento anexado"}
                        />
                        <SvgIcon
                          component={informationIcon}
                          onClick={() => {
                            setObservationReject(row.observation);
                            setShowRejectModalInfo(true);
                          }}
                          style={{
                            width: "20px",
                            height: "20px",
                            color: globalColors.backgroundColor2,
                            fill: "transparent",
                            cursor: "pointer",
                            display:
                              row.status === DocumentStatusEnum.REJECTED
                                ? "block"
                                : "none",
                            marginRight: "10px",
                          }}
                          title={"Informações sobre a rejeição"}
                        />
                        {row.files?.length > 0 && (
                          <SvgIcon
                            component={downloadIcon}
                            onClick={() => {
                              handleDownload(
                                row?.files.map((file) => ({
                                  name: file.name,
                                  fileKey: file.fileKey,
                                  id: file?.id,
                                  documentId: row?.id,
                                })),
                                row
                              );
                            }}
                            style={{
                              width: "20px",
                              height: "20px",
                              color: globalColors.backgroundColor2,
                              fill: "transparent",
                              cursor: "pointer",
                            }}
                            title={"Baixar documento anexado"}
                          />
                        )}
                      </div>
                    </StyledTableCell>
                    <StyledTableCell
                      style={{
                        padding: "4px 10px",
                        textAlign: "left",
                      }}
                    >
                      {row.documentCategory.name}
                    </StyledTableCell>
                    <StyledTableCell
                      style={{
                        padding: "4px 10px",
                        textAlign: "left",
                      }}
                    >
                      {row.files.length > 1
                        ? "Arquivos enviados"
                        : row.files.length === 1
                        ? row.files[0].name
                        : "Não enviado"}
                    </StyledTableCell>
                    <StyledTableCell
                      style={{
                        padding: "4px 10px",
                        textAlign: "center",
                      }}
                    >
                      {new Date(row.updatedAt).toLocaleDateString("pt-BR")}
                    </StyledTableCell>
                    <StyledTableCell
                      style={{
                        padding: "4px 10px",
                        textAlign: "center",
                        width: "100px",
                      }}
                    >
                      <Typography
                        style={{
                          backgroundColor: getLabelAndColorFromStatusHelper(
                            row.status
                          ).color,
                          display: "inline-block",
                          padding: "4px 6px",
                          margin: "0 4px",
                          borderRadius: "4px",
                          fontWeight: "500",
                          color: getLabelAndColorFromStatusHelper(row.status)
                            .textColor,
                        }}
                      >
                        {getLabelAndColorFromStatusHelper(row.status).label}
                      </Typography>
                    </StyledTableCell>
                  </StyledTableRow>
                ))}
              </TableBody>
            </Table>
          </Container>
        </Grid>
      </Container>
    </>
  );
};
